import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Header from '@components/Header';
import Footer from '@components/Footer';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const styles = theme => ({
  root: {
    paddingTop: 58,
  },
  contentContainer: {
    paddingTop: 55,
    paddingBottom: 55,
  },
});

const Index = ({ classes }) => {
  return (
    <div className={classes.root}>
      <Head>
        <title>About Us - SellOnLive</title>
      </Head>
      <Header />
      <div className={['container', classes.contentContainer].join(' ')}>
        <h1>About Us</h1>
        <p>
          SellOnLive commits to Live-Commerce Business Entrepreneurs to provide and establish
          exclusive Live-Commerce channels, sale website, live sell platform. Providing one stop
          Live-Commerce solution services, serving various live sellers, we serve live sellers in
          Malaysia, providing a stable and instant platform, giving seller a variety of intuitive
          experience, user-friendly sell services, get started quickly. SellOnLive places the great
          importance on buyer’s experience as much as seller’s experience, besides application for
          seller, No Matters you want to Sell or Buy, Go to SellOnLive +1
        </p>
        <br />
        <p>CONTACT US</p>

        <p>
          For more information about our privacy practices, if you have questions, or if you would
          like to make a complaint, please contact us by e-mail at help@sellonlive.tech or by mail
          using the details provided below:
        </p>

        <p>
          52-2, Jalan BS 1/1, Taman Bukit Serdang, Pusat Perdagangan Olive Hill, Sekysen 1, 43300
          Seri Kembangan Selangor
        </p>
      </div>
      <Footer />
    </div>
  );
};

export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      locale,
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

export default withStyles(styles)(Index);
